// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__lGHKZo","content":"content__gdlY_R"};